module.exports = __webpack_public_path__ + "static/media/fitfood.19de25ac.png";